// 原 CSS Modules 的类名映射，去掉构建哈希以便阅读。
export default {
  ack: "ConsentNotice__ack",
  chevron: "ConsentNotice__chevron",
  copy: "ConsentNotice__copy",
  details: "ConsentNotice__details",
  link: "ConsentNotice__link",
  notice: "ConsentNotice__notice",
  reveal: "ConsentNotice__reveal",
  revealInner: "ConsentNotice__revealInner",
  summary: "ConsentNotice__summary",
  summaryLabel: "ConsentNotice__summaryLabel",
};
